import React, { useState } from "react";
import { Button, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function CollapseButton({
  label,
  content,
  as = "button",
  ...props
}) {
  const [show, setShow] = useState(false);
  const Component = as;

  return (
    <Component
      className="btn d-flex p-0"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      {...props}
    >
      {label}

      <Collapse in={show} dimension="width">
        <div>
          <div className="mx-2 h-100"> {content}</div>
        </div>
      </Collapse>
    </Component>
  );
}
